import { Markdown } from './ai-markdown.jsx';
import { splitDisplayMath } from './ai-math-syntax.mjs';
const { useState, useMemo } = React;

function Computer() {
  return <svg className="win95-computer" viewBox="0 0 40 40" aria-hidden="true" shapeRendering="crispEdges"><path fill="#fff" d="M8 2h26v26H8zM5 28h31v6H5zM2 34h37v4H2z"/><path fill="#808080" d="M9 3h24v25H9zM6 29h29v5H6z"/><path fill="#c0c0c0" d="M10 4h21v22H10zM7 30h27v3H7zM3 35h34v2H3z"/><path fill="#000" d="M13 7h16v14H13zM16 26h13v2H16zM11 31h2v1h-2zm4 0h2v1h-2zm4 0h2v1h-2zm4 0h2v1h-2zm4 0h2v1h-2z"/><path fill="#008080" d="M15 9h12v10H15z"/><path fill="#fff" d="M17 11h8v6h-8z"/><path fill="#000080" d="M17 11h8v2h-8z"/><path fill="#00ffff" d="M17 15h5v2h-5z"/><path fill="#000" d="M34 2h1v27h-1zM36 29h1v5h-1zM39 34h1v5H2v-1h37z"/></svg>;
}

function sectionsFrom(text) {
  const sections = []; let current = { title: '', text: '' }, inCode = false;
  const finish = () => { if (current.title || current.text.trim()) sections.push(current); };
  for (const part of splitDisplayMath(text)) {
    if (part.type !== 'text') { current.text += part.raw || part.text; continue; }
    for (const line of part.text.split('\n')) {
      if (/^\s*```/.test(line)) inCode = !inCode;
      const title = !inCode && line.match(/^#{1,3}\s+(.+)$|^\*\*([^*]+)\*\*[：:]?\s*$/);
      if (title) { finish(); current = { title: (title[1] || title[2]).replace(/\*\*/g, ''), text: '' }; }
      else current.text += line + '\n';
    }
  }
  finish();
  return sections;
}

export function Win95Answer({ turn, onText, onSources, onCopy, onCitation }) {
  const [minimized, setMinimized] = useState(false);
  const sections = useMemo(() => sectionsFrom(turn.answer), [turn.answer]);
  return <section className={'win95-window' + (minimized ? ' minimized' : '')} aria-label="Windows 95 好看模式">
    <div className="win95-titlebar"><span className="win95-title-icon" aria-hidden="true">▧</span><strong>Web View</strong><div className="win95-window-actions"><button aria-label={minimized ? '还原回答窗口' : '最小化回答窗口'} title={minimized ? '还原' : '最小化'} aria-expanded={!minimized} onClick={() => setMinimized(!minimized)}>{minimized ? '▣' : '—'}</button><button aria-label="关闭好看模式，返回文本" title="返回文本模式" onClick={onText}>×</button></div></div>
    {!minimized && <>
      <div className="win95-toolbar"><button onClick={onCopy}>复制回答</button><button onClick={onSources}>查看来源 ({turn.sources.length})</button><span>Windows 95</span></div>
      <div className="win95-body">
        <header className="win95-banner"><Computer/><div><h2>{turn.question}</h2><span>Qomo AI Search · Internet Explorer</span></div></header>
        <div className="win95-document">
          {sections.map((section, index) => <section className={'win95-section' + (!section.title ? ' win95-intro' : '')} key={index}>
            {section.title && <h3><span className="win95-section-marker" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>{section.title}</h3>}
            <Markdown text={section.text} sources={turn.sources} onCitation={onCitation}/>
          </section>)}
        </div>
      </div>
      <footer className="win95-statusbar"><span>{turn.status === 'pending' ? '正在接收网页内容…' : turn.status === 'complete' ? '文档已完成' : turn.status === 'stopped' ? '已停止接收' : '文档未完整生成'}</span><span>{turn.sources.length} 个来源</span><span>Internet</span></footer>
    </>}
    {minimized && <button className="win95-restore" onClick={() => setMinimized(false)}>回答已最小化，点击还原</button>}
  </section>;
}
